import React from 'react';
import { Text } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { getOfferInclusionsList } from 'store/booking/bookingSelectors';

const OfferInclusions = () => {
  const offerInclusionsList = useSelector(getOfferInclusionsList);

  return (
    <Text color="greys.steel" fontSize="sm" lineHeight="loose" data-testid="inclusions-list">
      {offerInclusionsList.join(', ')}
    </Text>
  );
};

export default OfferInclusions;
